import React from "react";
import PropTypes from "prop-types";

export default function Close({ close }) {
  return (
    <button onClick={close} className="close" type="button">
      <span>
        <i className="fa fa-close" />
      </span>
    </button>
  );
}

Close.propTypes = {
  close: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/Modal/Close.jsx